/** Find the earliest available adjacent columns without overlapping earlier cards. */
export function findProfileGridSlot(columnRows: readonly number[], requestedSpan: 1 | 2) {
  const columnSpan = Math.min(requestedSpan, columnRows.length);
  let column = 0;
  let rowStart = Math.max(...columnRows.slice(0, columnSpan));

  for (let index = 1; index <= columnRows.length - columnSpan; index += 1) {
    const candidateRow = Math.max(...columnRows.slice(index, index + columnSpan));
    if (candidateRow < rowStart) {
      column = index;
      rowStart = candidateRow;
    }
  }

  return { column, columnSpan, rowStart };
}
